import Axios from "axios";
import queryString from 'query-string';
import { USER_API, PASSWORD_API } from '../service/api';

//Variables para conexión y ambientes

const test = process.env.REACT_APP_TEST;
const amb = test === "true" ? "TEST_" : "PROD_";
const cnxAPI = process.env.REACT_APP_CNXAPI;

// Las llamadas con axios directo a cnxAPI también deben enviar las credenciales del API
Axios.interceptors.request.use((config) => {
  if (cnxAPI && typeof config.url === "string" && config.url.startsWith(cnxAPI)) {
    config.headers.set("user-api", USER_API);
    config.headers.set("password-api", PASSWORD_API);
  }
  return config;
});

function notifica(tipo, mssg, titulo) {
  var inp_tip = document.getElementById("inp_Tipo"),
    inp_msg = document.getElementById("inp_Mssg"),
    inp_ttl = document.getElementById("inp_Ttl"),
    btn = document.getElementById("btn_Alert");
  if (inp_tip) inp_tip.value = tipo;
  if (inp_msg) inp_msg.value = mssg;
  if (inp_ttl) inp_ttl.value = titulo;
  if (btn) btn.click();
}
//Función para mostrar u ocultar el loader
function show_ldr(so) {
  var btn = so
    ? document.getElementById("btn_show")
    : document.getElementById("btn_hide");
  if (btn) btn.click();
}

//Función que obtiene información del usuario
function getUser() {
  var usr = sessionStorage.getItem(amb + "_User");
  if (usr !== null) {
    var js = JSON.parse(atob(unescape(decodeURIComponent(usr))));
    return js;
  } else {
    var loc = window.location.href,
      orig = window.origin + "/",
      pages = [
        "ofertas",
        "login",
        "registrarse",
        "cambiarContrasena",
        "Validacion",
      ];
    if (loc !== orig) {
      if (validarPaginas(loc.toString(), pages)) {
        if (loc.split("?").length > 1){
          var key = queryString.parseUrl(loc).query;
          if (key.vct === null) {
            localStorage.setItem("url", loc);
            window.location.href = loc.split("?")[0];
          }     
        } else {
          if (!validarPaginas(loc.toString(), pages)) {
            window.location.replace(orig);
          }
        }
      } else {
        window.location.replace(orig);
      }
    }
  }
}
function validarPaginas(url, lista) {
  var i = 0;
  if (Array.isArray(lista)) {
    lista.forEach(function (item) {
      if (url.indexOf(item) !== -1) {
        i++;
      }
    });
  }
  if (i === 0) return false;
  else return true;
}
//Función que confirma si el usuario está logeado
function checkUser() {
  var usr = sessionStorage.getItem(amb + "_User");
  if (usr === null) {
    return false;
  } else {
    return true;
  }
}

//Función que valida que los campos estén llenos
function validaCampos(clase) {
  var inps = document.querySelectorAll(clase),
    llenos = true;
  inps.forEach(function (i) {
    if (i.value === "") {
      llenos = false;
    }
  });
  return llenos;
}

//Función que cierra sesión
function LogOut() {
  sessionStorage.removeItem(amb + "_User");
  localStorage.removeItem("foto");
  localStorage.removeItem("sesion-mireclu");
  var orig = window.origin;
  window.location.replace(orig);
}

//Función para mostrar imágen pequeña cuando es cargada
function miniImagen(evt) {
  var files = evt.target.files;

  for (var i = 0, f; (f = files[i]); i++) {
    //Solo admitimos imágenes.
    if (!f.type.match("image.*")) {
      continue;
    }
    var reader = new FileReader();
    reader.onload = (function (theFile) {
      return function (e) {
        document.getElementById("list").innerHTML = [
          '<img class="thumbMiniImg" src="',
          e.target.result,
          '" title="',
          escape(theFile.name),
          '"/>',
        ].join("");
      };
    })(f);
    reader.readAsDataURL(f);
  }
}

//Función para mostrar u ocultar el loader dentro del modal
function show_mdl_ldr(so) {
  var ld = document.getElementById("md_ldr");
  var loadRec = document.getElementById("loading_recorder");
  if (ld !== null) {
    if (so) {
      ld.classList.remove("Hide_Half");
      loadRec.classList.remove("display_none");

      document.getElementById("dv_preguntas").classList.add("display_none");
      document.getElementById("dv_grabavideo").classList.add("display_none");
    } else {
      ld.classList.add("Hide_Half");
      loadRec.classList.add("display_none");

      document.getElementById("dv_preguntas").classList.remove("display_none");
      document.getElementById("dv_grabavideo").classList.remove("display_none");
    }
  }
}

const months = [
  { id: "00", value: "Selecciona..." },
  { id: "01", value: "Enero" },
  { id: "02", value: "Febrero" },
  { id: "03", value: "Marzo" },
  { id: "04", value: "Abril" },
  { id: "05", value: "Mayo" },
  { id: "06", value: "Junio" },
  { id: "07", value: "Julio" },
  { id: "08", value: "Agosto" },
  { id: "09", value: "Septiembre" },
  { id: "10", value: "Octubre" },
  { id: "11", value: "Noviembre" },
  { id: "12", value: "Diciembre" },
];

const instance = Axios.create({
  baseURL: cnxAPI,
  headers: {
    "Content-Type": "application/json; charset=utf-8",
    "X-Requested-With": "XMLHttpRequest",
  },
});

const responseBuild = async (response) => {
  const { status, data } = response;
  if (status === 500) {
    notifica("error", data.error, "Error");
    return null;
  } else if (status === 200) {
    return data;
  } else if (status === 201) {
    if (data) {
      notifica("success", data.mensaje, "");
    }
    return data;
  } else if (status === 204) {
    notifica("success", "Se actualizó correctamente", "success", "ok");
    return;
  } else if (status === 401) {
    if (data) {
      notifica("warning", data, "Advertencia");
    } else {
      notifica(
        "warning",
        "Tu sesion a expirado favor de ingresar de nuevo",
        "Advertencia"
      );
    }
    return null;
  } else if (status === 404) {
    if (data) {
      notifica("warning", data, "Advertencia");
    }
    return null;
  }else if (status === 409) {
    if (data) {
      notifica("warning", data.message, "Advertencia");
    }
    return null;
  } else {
    notifica("error", "Error desconocido", "Error");
    return null;
  }
};
const buildFullNameUser = ({ firtsName, middleName, lastName }) => {
  return `${firtsName || ""} ${middleName || ""} ${lastName || ""}`;
};

export {
  amb,
  cnxAPI,
  notifica,
  show_ldr,
  getUser,
  validaCampos,
  checkUser,
  LogOut,
  miniImagen,
  show_mdl_ldr,
  months,
  instance,
  responseBuild,
  buildFullNameUser,
};
